import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { ApiTitleComponent } from '../../common/api-title/api-title.component';
import { ApiUIResponseComponent } from '../api-ui-response/api-ui-response.component';
import { GlobalContants, Resource } from 'src/app/constants/global.contants';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';
import { HTTPMethod } from 'src/app/constants/enum';
import { apiEndPoints } from 'src/app/constants/api-endpointsconstant';

export interface statusCode {
  key: string;
  value: string;
  required: boolean
}

const Headers: statusCode[] = [
  {
    key : "Content-Type",
    value: 'application/json',
    required: false
  },
  {
    key : "API-KEY",
    value: '{{API-KEY}}',
    required: true
  },
  {
    key : "USER-TOKEN",
    value: '{{USER-TOKEN}}',
    required: true
  },
    {
    key : "CITY-CODE",
    value: '{{CITY-CODE}}',
    required: true
  },
];
const QueryData :any =[
  {
    param : "limit",
    value: '{{limit}}',
    required: false
  },
  {
    param : "offset",
    value: '{{offset}}',
    required: false
  },
  {
    param : "filter",
    value: '{{filter}} Filter value in json format e.g.',
    code: `{
  "property_uid": "",
  "floor_uid": "",
  "floor_number": "",
}`,
    required: false
}
]

@Component({
  selector: 'app-dallal-floor',
  standalone: true,
  imports: [ 
    CommonModule,
    MaterialModule,
    RouterModule,
    ApiTitleComponent,
    ApiUIResponseComponent,],
  templateUrl: './dallal-floor.component.html'
})
export class DallalFloorComponent {
  HTTPMethod = HTTPMethod;
  displayedColumns: string[] = ['key', 'value', 'required'];
  QueryColumns: string[] = ['param', 'value', 'required'];
  dataSource = Headers;
  QueryDataSource = QueryData;

  api_ui: boolean = false;

  GlobalContants = GlobalContants
  constructor(private sharedService: SharedService, 
          private userService: UserService, 
          private router: Router){
    
  }

  ngOnInit() {
    let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
        this.userService.getAllUserResource(userInfo.user_id)
          .subscribe({
            next: (res: any) => {
              const matched = res.data.find((r: any) => r.resource_name === Resource.Floor);
                if (!matched?.methods?.includes(HTTPMethod.GET)) {
                  this.router.navigate(['/'])
                }
            },
            error: (err) => {
            }
          })
   }

  ngAfterViewInit(){
  }

  api_demo= `${environment.apiBaseUrl}${apiEndPoints.floors}`;

  api_response = `
{
  "status": 0,
  "message": "string",
  "data": 
  {
  "property_uid": "TSTLA00000",
  "floor_number": 2,
  "floor_type": "Typical_Floor",
  "floor_uid": "TSTFA00004",
  "parking_covered_parking_value": 0,
  "parking_open_parking_value": 0,
  "parking_shaded_parking_value": 0,
  "parking_covered_floor_area": 0,
  "parking_open_floor_area": 0,
  "parking_shaded_floor_area": 0,
  "floor_name": "Upper_Ground",
  "parking_covered_parking_area": 0,
  "parking_open_parking_area": 0,
  "parking_shaded_parking_area": 0
}
}`;
}
